// extracted by mini-css-extract-plugin
module.exports = {"Sidebar":"controller_Sidebar__vNNfO","Links":"controller_Links__1Zeik","Main":"controller_Main__24UnJ"};